import { Spacing, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const SalaryFeaturesListWrapper = styled.div``

export const IllustrationWrapper = styled.figure`
  display: flex;
  justify-content: center;
  margin-bottom: ${Spacing.S24};
`

export const Illustration = styled.img`
  width: 262px;
  height: 207px;
`

export const TitleWrapper = styled.div`
  margin-bottom: ${Spacing.S32};
`

export const TextStriked = styled(TextComponent)`
  text-decoration: line-through;
`

export const FeaturesList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${Spacing.S8};
`

export const FeatureItem = styled.li`
  display: flex;
  width: calc(50% - ${Spacing.S16});
  margin-bottom: ${Spacing.S24};

  &:nth-of-type(2n) {
    margin-left: ${Spacing.S32};
  }
`

export const IconWrapper = styled.div`
  display: flex;
  margin-right: ${Spacing.S8};
  padding-top: ${Spacing.S4};
`
